import SolicitacaoService from "../../services/resource/solicitacaoService";

const solicitacaoService = new SolicitacaoService();

/**
 * Envia os comentários registrados durante o preenchimento da Etapa 1 (staged em memória) depois
 * que a solicitação foi criada e o ID retornado — a API só aceita comentário após existir o
 * registro. Falhas individuais não interrompem os demais envios.
 */
export async function enviarComentariosStaged(solicitacaoId, itensStaged) {
    if (!itensStaged || itensStaged.length === 0) {
        return { sucesso: [], falha: [] };
    }

    const resultados = await Promise.allSettled(
        itensStaged.map(item => solicitacaoService.comentar(solicitacaoId, { texto: item.texto }))
    );

    const sucesso = [];
    const falha = [];
    resultados.forEach((resultado, indice) => {
        if (resultado.status === "fulfilled") {
            sucesso.push(itensStaged[indice]);
        } else {
            falha.push(itensStaged[indice]);
        }
    });

    return { sucesso, falha };
}
